import angular from 'angular';

angular
  .module('message')

  .factory('MessageService', [
    '$resource',
    'CONF',
    'API_CONFIG',
    function($resource, CONF, API_CONFIG) {
      var Message = $resource(
        API_CONFIG.url + '/v1/message/:messageId',
        { messageId: '@id' },
        {
          // Recherche suivant les critères
          searchByCriterias: {
            method: 'POST',
            url: API_CONFIG.url + '/v1/message/searchByCriterias',
            isArray: true
          },
          // Recherche les différents code de traitement
          findCodeTreatments: {
            method: 'GET',
            url: API_CONFIG.url + '/v1/message/findCodeTreatments',
            isArray: true
          }
        }
      );

      // Récupération du message au format XML
      Message.getXmlMessage = function(messageId) {
        return API_CONFIG.url + '/v1/message/' + messageId + '/xml';
      };

      return Message;
    }
  ]);
